import React from 'react';
import textDecoration from '../../assets/about/textDecoration.png'
import proficiency from '../../assets/about/proficiencyChart.png'

import './style.css'

function About() {
    return (
        <div id='about'>
            <section className='About'>
                <h2 id='aboutTitle'>About me</h2>
                <p id='aboutText'>Working in the area of ​​software development since for 4 years,
                I seek to serve my customers with sensitivity and precision. I've made this website using React.js.
                My Skills are described below:</p>
                <p id='aboutComplement'>I love to code and I love to learn.</p>
                <img id='proficiency' src={proficiency}></img>
            </section>
        </div>
    );
}

export default About;